<template>
  <div class="container-lg">
    <h1 class="page-header">User</h1>
    <div v-if="user && (user.id===1 || user.id===item.id)">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="handleSubmit()" name="form">
          <div class="form-group row">
            <label class="col-md-3">Username</label>
            <div class="col-md-9">
              <ValidationProvider name="Username" rules="required" v-slot="{ errors }">
                <input class="form-control" type="text" v-model="item.username" />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3">Password</label>
            <div class="col-md-9">
              <ValidationProvider
                name="Password"
                :rules="(item.id ? '' : 'required|') +'min:6'"
                v-slot="{ errors }"
              >
                <input class="form-control" type="password" v-model="item.password" />
                <small v-show="item.id">Blank to leave unchanged</small>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3">Name</label>
            <div class="col-md-9">
              <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                <input class="form-control" type="text" v-model="item.name" />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3">Role</label>
            <div class="col-md-9">
              <ValidationProvider name="role" rules="required" v-slot="{ errors }">
                <select class="form-control" v-model="item.role">
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3">Email</label>
            <div class="col-md-9">
              <ValidationProvider name="Email" rules="email" v-slot="{ errors }">
                <input class="form-control" type="text" v-model="item.email" />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12 text-right">
              <button class="btn btn-light mr-4" type="button" @click="$router.back()">Cancel</button>
              <button class="btn btn-primary" type="submit" :disabled="invalid">Save</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <div v-else>You are not authorised to edit this user.</div>
  </div>
</template>

<script>
import { authFetch, getUser } from "../lib/auth.js";

export default {
  props: {
    id: String,
  },
  data() {
    return {
      item: {
        // Add fields here so vue watches all fields for changes
        id: null,
        username: "",
        name: "",
        email: "",
      },
      user: null,
    };
  },
  created() {
    this.load();
  },
  watch: {
    id() {
      this.load();
    },
  },
  methods: {
    handleSubmit() {
      if (this.item.id) {
        // Update existing
        authFetch("/db/user/" + this.item.id, {
          method: "put",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              this.$router.back();
              return;
            default:
              resp.text().then((t) => {
                alert(t);
              });
          }
        });
      } else {
        // Add new
        authFetch("/db/user", {
          method: "post",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              resp.text().then((id) => {
                this.item.id = parseInt(id);
              });
              this.$router.back();
              return;
            default:
              resp.text().then((t) => {
                alert(t);
              });
          }
        });
      }
    },
    load() {
      getUser().then((user) => (this.user = user));

      if (!this.id) {
        Object.assign(this.item, {
          id: null,
          name: "",
        });
        return;
      } else {
        authFetch("/db/user/" + this.id)
          .then((resp) => resp.json())
          .then((data) => {
            Object.assign(this.item, data);
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>